import * as React from "react";
import { initializeIcons, registerIcons } from "@fluentui/react";
import { initializeFileTypeIcons } from "@fluentui/react-file-type-icons";
import { AcceptIcon, CalendarIcon, ParticipantAddIcon } from "@fluentui/react-icons-northstar";
/**
 * Common React utilities
 */ /**
 * Replace newlines in a string with <br/> elements to preserve newlines
 * @param inputString String to replace newlines
 */ export function replaceNewlinesWithBr(inputString) {
    const descriptionElements = [];
    let newlinePos = 0;
    while(newlinePos < inputString.length){
        const newlineIdx = inputString.indexOf("\n", newlinePos);
        if (newlineIdx === -1) {
            break;
        }
        const newlineSubstr = inputString.substring(newlinePos, newlineIdx);
        if (newlineSubstr) {
            descriptionElements.push(/*#__PURE__*/ React.createElement(React.Fragment, null, newlineSubstr));
        }
        descriptionElements.push(/*#__PURE__*/ React.createElement("br", null));
        newlinePos = newlineIdx + 1;
    }
    if (newlinePos < inputString.length) {
        descriptionElements.push(/*#__PURE__*/ React.createElement(React.Fragment, null, inputString.substring(newlinePos)));
    }
    return descriptionElements;
}
/**
 * Note: This is duplicated as is from tasks/ui package
 */ export function initializeAndRegisterIcons() {
    // Initialize OfficeFabric icons
    initializeIcons();
    // Register icons and pull the fonts from the default SharePoint cdn.
    initializeFileTypeIcons();
    // Register stardust icons to be used with office fabric
    registerIcons({
        icons: {
            Accept: /*#__PURE__*/ React.createElement(AcceptIcon, null),
            ParticipantAddIconOutlined: /*#__PURE__*/ React.createElement(ParticipantAddIcon, {
                outline: true
            }),
            CalendarIconOutlined: /*#__PURE__*/ React.createElement(CalendarIcon, {
                outline: true
            }),
            "publishing-filter": /*#__PURE__*/ React.createElement("svg", {
                width: "24",
                height: "24",
                viewBox: "0 0 24 24",
                fill: "none",
                xmlns: "https://www.w3.org/2000/svg"
            }, /*#__PURE__*/ React.createElement("path", {
                d: "M10 16H14C14.5523 16 15 16.4477 15 17C15 17.5128 14.614 17.9355 14.1166 17.9933L14 18H10C9.44772 18 9 17.5523 9 17C9 16.4872 9.38604 16.0645 9.88338 16.0067L10 16H14H10ZM8 11H16C16.5523 11 17 11.4477 17 12C17 12.5128 16.614 12.9355 16.1166 12.9933L16 13H8C7.44772 13 7 12.5523 7 12C7 11.4872 7.38604 11.0645 7.88338 11.0067L8 11H16H8ZM5 6H19C19.5523 6 20 6.44772 20 7C20 7.51284 19.614 7.93551 19.1166 7.99327L19 8H5C4.44772 8 4 7.55228 4 7C4 6.48716 4.38604 6.06449 4.88338 6.00673L5 6H19H5Z",
                fill: "#8B8CC7"
            })),
            "teamsLightIcon Channel": /*#__PURE__*/ React.createElement("span", {
                className: "teamsLightIcon Channel"
            }),
            "teamsLightIcon flag": /*#__PURE__*/ React.createElement("span", {
                className: "teamsLightIcon flag"
            }),
            "teamsLightIcon delete": /*#__PURE__*/ React.createElement("span", {
                className: "teamsLightIcon delete"
            }),
            "teamsLightIcon edit": /*#__PURE__*/ React.createElement("span", {
                className: "teamsLightIcon edit"
            }),
            "teamsLightIcon meeting": /*#__PURE__*/ React.createElement("span", {
                className: "teamsLightIcon meeting"
            }),
            "teamsLightIcon participantAdd": /*#__PURE__*/ React.createElement("span", {
                className: "teamsLightIcon participantAdd"
            }),
            "teamsLightIcon myDay": /*#__PURE__*/ React.createElement("span", {
                className: "teamsLightIcon myDay"
            }),
            "teamsLightIcon Link": /*#__PURE__*/ React.createElement("span", {
                className: "teamsLightIcon Link"
            }),
            "teamsLightIcon Reload": /*#__PURE__*/ React.createElement("span", {
                className: "teamsLightIcon Reload"
            })
        }
    });
}
/**
 * Formats a template string with the provided values.
 * @param template The template string containing placeholders.
 * @param values The values to replace the placeholders with including booleans, numbers, strings and JSX elements.
 * @returns The formatted JSX element.
 */ export function formatJsx(template, ...values) {
    const parts = [];
    const placeholderRegex = /\{(\d+)\}/g;
    let lastIndex = 0;
    let match;
    while((match = placeholderRegex.exec(template)) !== null){
        // Push preceding text
        if (match.index > lastIndex) {
            parts.push(template.slice(lastIndex, match.index));
        }
        const index = Number(match[1]);
        let replacement = values[index];
        // Map null/undefined to empty string, and booleans to text to match string formatter behavior
        if (replacement === null) {
            replacement = "";
        } else if (typeof replacement === "boolean") {
            replacement = String(replacement);
        }
        parts.push(replacement);
        lastIndex = placeholderRegex.lastIndex;
    }
    // Trailing text
    if (lastIndex < template.length) {
        parts.push(template.slice(lastIndex));
    }
    return /*#__PURE__*/ React.createElement(React.Fragment, null, parts.map((part, i)=>/*#__PURE__*/ React.createElement(React.Fragment, {
            key: i
        }, part)));
}
